export default __webpack_public_path__ + "static/media/slider-cregar-3.ce9413cf.jpg";